<template>
  <div class="content">
    <div class="body" :loading="listLoading">
      <div class="search-box">
        <div class="input-item">
          <span class="label">用户姓名</span>
          <Input v-model="searchParams.name" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">手机号</span>
          <Input v-model="searchParams.mobile" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">登录账号</span>
          <Input v-model="searchParams.account" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">状态</span>
          <RadioGroup v-model="searchParams.status" @on-change="searchAjax()">
            <Radio label="">全部</Radio>
            <Radio label="1">启用</Radio>
            <Radio label="0">禁用</Radio>
          </RadioGroup>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
        </div>
      </div>
      <div class="tools-box right">
        <Button type="primary" @click="editUser()">新增</Button>
      </div>
      <div class="table-box">
        <loading :isShow="listLoading" />

        <Table :columns="columns" :data="tableData">
          <!-- 业务员 -->
          <template slot-scope="{ row }" slot="name">
            <div class="user-box">
              <span class="user-name">{{ row.name }}</span>
            </div>
          </template>
          <!-- 账号 -->
          <template slot-scope="{ row }" slot="account">
            <span class="text descrypt-text" @dblclick="openEye(row, 'account')">{{ row.account }}</span>
            <template v-if="row.account && !row.mobileEyeShow">
              <a>
                <i class="iconfont iconyincang eye-icon" @click="openEye(row, 'account')"></i>
              </a>
            </template>
          </template>
          <!-- 手机号 -->
          <template slot-scope="{ row }" slot="mobile">
            <span class="text descrypt-text" @dblclick="openEye(row, 'mobile')">{{ row.mobile }}</span>
            <template v-if="row.mobile && !row.mobileEyeShow">
              <a>
                <i class="iconfont iconyincang eye-icon" @click="openEye(row, 'mobile')"></i>
              </a>
            </template>
          </template>
          <template slot-scope="{ row }" slot="status">
            <!--  v-if="row.isDel == 1" -->
            <i-Switch size="large" v-model="row.status" @on-change="changeStatus(row, $event)" false-value="0" true-value="1">
              <span slot="open">启用</span> <span slot="close">禁用</span></i-Switch
            >
            <!-- <span v-else>{{ row.status == 1 ? '已启用' : '已禁用' }}</span> -->
          </template>
          <template slot-scope="{ row }" slot="action">
            <template>
              <div></div>
            </template>
            <span class="table-btn" @click="editUser(row)">编辑</span>
            <span class="table-btn" @click="resetPassword(row)">重置密码</span>
            <span class="table-btn" :disabled="row.isDel == 0" style="color: red" @click="delUser(row)">删除</span>
          </template>
        </Table>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
      </div>
    </div>
    <!-- 重置密码 -->
    <password-form ref="passwordForm"></password-form>
    <!-- 新增/编辑员工 -->
    <edit-user ref="editUser" @success="getList()" @editPassword="item => resetPassword(item)"></edit-user>

    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>
<script>
import editUser from './components/editUser';
import { pageTool, common } from '@/api/mixins';
import passwordForm from './components/passwordForm';
import validUserName from '@/components/commons/validUserName';
export default {
  mixins: [pageTool, common],
  components: { editUser, passwordForm, validUserName },
  data: () => ({
    searchParams: { type: 3 },
    columns: [
      {
        title: '用户姓名',
        slot: 'name',
        align: 'center',
        minWidth: 160
      },
      {
        title: '手机号',
        slot: 'mobile',
        minWidth: 160,
        align: 'center'
      },
      {
        title: '登录账号',
        slot: 'account',
        minWidth: 160,
        align: 'center'
      },
      {
        title: '状态',
        slot: 'status',
        minWidth: 160,
        align: 'center'
      },
      {
        title: '创建时间',
        key: 'createTime',
        align: 'center',
        minWidth: 160,
        render(h, params) {
          return <div>{params.row.createTime.split(' ')[0]}</div>;
        }
      },
      {
        title: '操作',
        slot: 'action',
        align: 'center',
        width: '180',
        fixed: 'right'
      }
    ]
  }),
  mounted() { },
  created() {
    this.initListAjax('/buz/userBase/read/list');
  },
  methods: {
    // 删除业务员
    delUser(item) {
      if (item.isDel == 0) {
        return;
      }
      this.$notice.inquiry('请确认是否删除此账号？').then(async () => {
        this.$http({
          url: '/buz/userBase/del',
          type: 'GET',
          data: {
            id: item.id
          }
        }).then(res => {
          this.$notice.success('操作成功');
          this.pageNum = 1;
          this.getList();
        });
      });
    },
    // 解密
    openEye(row, key) {
      if (!row['validName' + key]) {
        this.$refs.validUserNameRef.open(row, key);
        return;
      }
      if (!row[key + 'EyeShow']) {
        const map = {
          account: 0,
          mobile: 2,
          idNo: 1,
        };
        this.descrypt(
          {
            query: row.id,
            operationFunction: 1,
            operationType: map[key]
          },
          row,
          key
        ).then(() => {
          this.$set(row, key + 'EyeShow', true);
        });
      } else {
        this.$set(row, key + 'EyeShow', false);
      }
    },
    // 重置密码
    resetPassword(item) {
      this.$refs.passwordForm.open(item);
    },
    changeStatus(row, status) {
      this.$notice
        .inquiry(`确认账号状态？`)
        .then(() => {
          this.$http({
            url: '/buz/userBase/edit',
            type: 'POST',
            data: {
              id: row.id,
              status
            }
          }).then(res => {
            this.$notice.success('操作成功');
            this.getList();
          });
        })
        .catch(() => {
          row.status = status == '1' ? '0' : '1';
        });
    },
    editUser(row = {}) {
      let data = {};
      if (row.id) {
        data.id = row.id;
      }
      this.$refs.editUser.open(data);
    },
    // 页面切换
    pageChange(index) {
      this.pageNum = index;
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
.table-btn {
  &[disabled] {
    opacity: 0.7;
    color: #999 !important;
    pointer-events: none;
  }
}
</style>
